import Vue from 'vue';
import ls from './tools/ls';

export default {
  namespaced: true,
  state: {
    items: ls.init('items', Array, []),
  },
  getters: {
    index: (state) => ({ _id }) => state.items.findIndex((item) => item._id === _id),
    totals: (state) => {
      const out = { price: 0, weight: 0, quantity: 0 };
      state.items.forEach((item) => {
        if (!item || !item.commodity) return;
        out.quantity += item.quantity;
        out.price += item.commodity.priceFinal * item.quantity;
        out.weight += (item.commodity.weight || 0) * item.quantity;
      });
      return out;
    },
  },
  actions: {
    plus({ commit, getters }, item) {
      const index = getters.index(item);
      if (index > -1) {
        commit('quantity', { index, increment: 1 });
      } else {
        commit('push', { ...item, quantity: 1 });
      }
    },
    minus({ commit, state, getters }, item) {
      const index = getters.index(item);
      if (index > -1) {
        if (state.items[index].quantity > 1) {
          commit('quantity', { index, increment: -1 });
        } else {
          commit('splice', index);
        }
      }
    },
    remove({ commit, getters }, item) {
      const idx = getters.index(item);
      if (idx > -1) {
        commit('splice', idx);
      }
    }
  },
  mutations: {
    quantity(state, { index, increment }) {
      state.items[index].quantity += increment;
      Vue.set(state, 'items', state.items);
      ls.set('items', state.items);
    },
    push(state, item) {
      state.items.push(item);
      ls.set('items', state.items);
    },
    splice(state, idx) {
      state.items.splice(idx, 1);
      ls.set('items', state.items);
    },
    clear(state) {
      Vue.set(state, 'items', []);
      ls.set('items', state.items);
    }
  },
};
